import { computed, getCurrentInstance } from 'vue';
import { NodeSamlSession, NodeSamlState } from './types';

export function useNodeSamlStore() {
    const vm = getCurrentInstance();

    const state = computed(() => vm.proxy.$store.state.auth.nodeSaml as NodeSamlState);
    const acsRedirectDataDetail = computed(() => state.value.detail);
    const acsRedirectDataState = computed(() => state.value.acsRedirectData);

    const getSamlSession = computed(() => vm.proxy.$store.getters['auth/nodeSaml/samlSession']() as NodeSamlSession);

    async function setData(payload: NodeSamlSession) {
        await vm.proxy.$store.dispatch('auth/nodeSaml/setData', payload);
    }
    async function clearData() {
        await vm.proxy.$store.dispatch('auth/nodeSaml/clearData');
    }
    async function acsRedirectData(session_id: string, relay_state: string) {
        await vm.proxy.$store.dispatch('auth/nodeSaml/acsRedirectData', { session_id, relay_state });
    }

    return {
        acsRedirectDataDetail,
        acsRedirectDataState,
        getSamlSession,
        setData,
        clearData,
        acsRedirectData,
    };
}
